export default __webpack_public_path__ + "static/media/ab-testing.fd6cf0b3.svg";